import { alpha } from '@mui/material';

const getRangeStyles = (theme) => {
    const rangeColor = alpha(theme.palette.primary.main, 0.2);
    return `    
    :after {
      width: 4px;
      height: 32px;
      background-color: ${rangeColor};
      content: "";
      position: absolute;
      top: 0px;
      left: -4px;
      right: 0;
      bottom: 0;
      pointer-events: none;
      border-right: none;
      border-left: none;  
    }
    background-color:  ${rangeColor} !important;
  `;
};
const getSelectedStyle = (theme, withBorders) => {
    return `
    ${getRangeStyles(theme)};
    :after {
      ${withBorders && `border: 1px solid ${theme.palette.primary.main};`};
      border-left: 0;
      border-right: 0;  
    }
    :before {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      ${withBorders &&
        `
        border-top: 1px solid ${theme.palette.primary.main};
        border-bottom: 1px solid ${theme.palette.primary.main};
      `};
    }

    ${withBorders &&
        `
      :first-of-type:before {
        border-left: 1px solid ${theme.palette.primary.main};
        border-bottom-left-radius: 50%;
        border-top-left-radius: 50%;
      }

      :last-of-type:before {
        border-right: 1px solid ${theme.palette.primary.main};
        border-bottom-right-radius: 50%;
        border-top-right-radius: 50%;
      }`};
  `;
};

export { getSelectedStyle as default, getRangeStyles };
//# sourceMappingURL=getSelectedStyle.js.map
